/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommentDto } from '../../models/comment-dto';
import { UpdatePostCommentDto } from '../../models/update-post-comment-dto';

export interface PostClientControllerUpdateCommentV1$Params {
  id: string;
      body: UpdatePostCommentDto
}

export function postClientControllerUpdateCommentV1(http: HttpClient, rootUrl: string, params: PostClientControllerUpdateCommentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
  const rb = new RequestBuilder(rootUrl, postClientControllerUpdateCommentV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommentDto>;
    })
  );
}

postClientControllerUpdateCommentV1.PATH = '/api/v1/posts/client/comment/{id}';
